import { render, staticRenderFns } from "./AnswerTemplate.vue?vue&type=template&id=b76969f4&scoped=true&"
import script from "./AnswerTemplate.vue?vue&type=script&lang=js&"
export * from "./AnswerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AnswerTemplate.vue?vue&type=style&index=0&id=b76969f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76969f4",
  null
  
)

export default component.exports